import React, { useEffect, useState } from 'react';
import { ArrowUpIcon } from './FencingIcons';

export default function ScrollToTopButton({ threshold = 200 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > threshold);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      style={{
        position: 'fixed',
        bottom: 80,
        right: 32,
        zIndex: 1000,
        width: 54,
        height: 54,
        borderRadius: '50%',
        background: '#1976d2',
        color: '#fff',
        border: 'none',
        boxShadow: '0 4px 16px #1976d277',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'background 0.2s, box-shadow 0.2s',
        fontSize: 32,
        outline: 'none',
      }}
      aria-label="Torna su"
      title="Torna in alto"
    >
      <ArrowUpIcon style={{ fontSize: 28, color: '#fff' }} />
    </button>
  );
}
